import React from "react";
import { useTranslation } from "react-i18next";
import { UUID } from "src/api/api_common";
import { ApiInternal } from "src/api/api_internal";
import { ConfirmDialog } from "src/components/base/confirm-dialog";

/**
 * The properties for {@link DeleteSubnetDialog}
 */
export type DeleteSubnetDialogProps = {
    /** Whether the dialog is open */
    isOpen: boolean;
    /** Callback for closing the popup */
    onClose: () => void;
    /** Callback for successful deletion */
    onDeletion: () => void;
    /** The subnet */
    subnet:
        | {
              /** Name of the subnet */
              name: string;
              /** UUID of the subnet */
              uuid: UUID;
          }
        | undefined;
};

/**
 * Dialog to delete a given subnet
 */
export default function DeleteSubnetDialog(props: DeleteSubnetDialogProps) {
    const [t] = useTranslation("dialog-delete-subnet");

    if (!props.subnet) return null;

    return (
        <ConfirmDialog
            open={props.isOpen}
            onClose={props.onClose}
            onConfirm={async () => {
                if (!props.subnet) return;
                await ApiInternal.subnets.delete(props.subnet.uuid);
                props.onDeletion();
            }}
            title={t("heading.delete-subnet", { subnet: props.subnet.name })}
            description={t("description.delete-subnet")}
            confirmLabel={t("button.delete-subnet")}
        />
    );
}
